
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/[slug]",
      function () {
        return require("private-next-pages/success-stories/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/[slug]"])
      });
    }
  